import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, ReferenceArea } from 'recharts';

const zones = [
  { y1: 0, y2: 30, color: '#F8FAFC', label: 'Newbie' },
  { y1: 30, y2: 50, color: '#ECFDF5', label: 'Apprentice' },
  { y1: 50, y2: 70, color: '#ECFEFF', label: 'Specialist' },
  { y1: 70, y2: 85, color: '#EFF6FF', label: 'Expert' },
  { y1: 85, y2: 95, color: '#FAF5FF', label: 'Master' },
  { y1: 95, y2: 100, color: '#FEF2F2', label: 'Grandmaster' },
];


const ProgressChart = ({ data }) => {
  return (
    <div className="w-full h-[320px]">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
          <defs>
            <linearGradient id="colorOverall" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#10E58F" stopOpacity={0.15}/>
              <stop offset="95%" stopColor="#10E58F" stopOpacity={0}/>
            </linearGradient>
            <linearGradient id="colorTechnical" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#6366F1" stopOpacity={0.1}/>
              <stop offset="95%" stopColor="#6366F1" stopOpacity={0}/>
            </linearGradient>
            <linearGradient id="colorSoftSkills" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#F59E0B" stopOpacity={0.1}/>
              <stop offset="95%" stopColor="#F59E0B" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#F1F5F9" />
          <XAxis 
            dataKey="date" 
            axisLine={false} 
            tickLine={false} 
            tick={{ fill: '#94A3B8', fontSize: 10, fontWeight: 700 }}
            dy={15}
            padding={{ left: 20, right: 20 }}
          />
          <YAxis 
            axisLine={false} 
            tickLine={false} 
            tick={{ fill: '#94A3B8', fontSize: 10, fontWeight: 700 }}
            domain={[0, 100]}
          />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: '#FFFFFF', 
              border: '1px solid #F1F5F9', 
              borderRadius: '12px', 
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
              fontSize: '11px',
              fontWeight: 700,
              padding: '10px 14px'
            }} 
            itemStyle={{ fontSize: '11px', fontWeight: 700 }}
            cursor={{ stroke: '#10E58F', strokeWidth: 1, strokeDasharray: '4 4' }}
          />
          <Legend 
            verticalAlign="top" 
            align="right" 
            iconType="circle" 
            wrapperStyle={{ paddingBottom: '20px', fontSize: '10px', fontWeight: 800, letterSpacing: '0.05em' }}
          />
          {/* Rank Zones */}
          {zones.map((zone, idx) => (
            <ReferenceArea 
              key={idx}
              y1={zone.y1} 
              y2={zone.y2} 
              fill={zone.color} 
              fillOpacity={0.4} 
            />
          ))}

          <Area 
            type="monotone" 
            dataKey="overall" 
            name="Overall"
            stroke="#10E58F" 
            strokeWidth={4} 
            fillOpacity={1} 
            fill="url(#colorOverall)" 
            dot={{ r: 3, fill: '#FFFFFF', stroke: '#10E58F', strokeWidth: 2 }}
            activeDot={{ r: 5, fill: '#10E58F', stroke: '#FFFFFF', strokeWidth: 2 }}
          />
          <Area 
            type="monotone" 
            dataKey="technical" 
            name="Technical"
            stroke="#6366F1" 
            strokeWidth={2} 
            strokeDasharray="5 5"
            fillOpacity={1} 
            fill="url(#colorTechnical)" 
            dot={false}
          />
          <Area 
            type="monotone" 
            dataKey="communication" 
            name="Communication"
            stroke="#F59E0B" 
            strokeWidth={2} 
            strokeDasharray="5 5"
            fillOpacity={1} 
            fill="url(#colorSoftSkills)" 
            dot={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ProgressChart;
